import { InsightGenericData } from 'apis/merchant-gateway/insights/types';

export enum AnalyticsAPICampaignType {
  AD = 'ad',
  PROMOTION = 'promotion',
}

export type CampaignPerformanceTotals = {
  totalSales: number;
  totalSpend: number;
  totalOrders: number;
  currency: string;
  avgBasketValue: number; // monetary value
  avgBasketSize: number; // avg count of items in the basket, not monetary value
  avgCostPerOrder: number;
  newCustomers: number | null;
  returningCustomers: number | null;
  percentageCoveredByWolt?: number;
  totalMerchantSpend?: number;
  totalWoltSpend?: number;
};

export type CampaignPerformance = {
  campaignId: string | null;
  campaignType: AnalyticsAPICampaignType | null;
  total: CampaignPerformanceTotals;
};
/**
 * @link Backend Schema https://github.com/creditornot/merchant-analytics-api/blob/48f1ad361a8b5085ccf722ea87da919221e522ee/insights/src/main/kotlin/com/wolt/merchantanalyticsapi/insights/http/InsightsCampaignPerformanceResponse.kt#L3
 */
export type CampaignsPerformanceResponse = InsightGenericData & {
  data: {
    campaignPerformance: CampaignPerformance;
  };
};
